<template>
  <main class="login">
    <div class="login__background">
      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#E3F0FF"
          d="M35.6,-63.5C48.5,-54.3,62.8,-49.4,73.3,-39.6C83.8,-29.7,90.5,-14.8,87.9,-1.5C85.2,11.8,73.3,23.6,61.6,31.4C49.9,39.3,38.5,43.1,28.3,51.8C18.1,60.5,9,74,-0.7,75.2C-10.4,76.3,-20.8,65.1,-32.3,57.2C-43.8,49.3,-56.5,44.6,-65.4,35.6C-74.3,26.6,-79.4,13.3,-78.7,0.4C-78,-12.5,-71.5,-25,-61.6,-32.2C-51.7,-39.5,-38.3,-41.4,-27.5,-51.7C-16.7,-62.1,-8.3,-80.9,1.5,-83.5C11.4,-86.2,22.8,-72.7,35.6,-63.5Z"
          transform="translate(100 100)"
        />
      </svg>
    </div>

    <section v-show="isload" class="login__loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-12">
            <div class="login_form">
              <h1 class="mb-5">
                اهلا <br />
                مرحبا بك مره اخري
              </h1>
              <form @submit.prevent="register">
                <div class="mb-3 form-group">
                  <label for="adminEmail" class="form-label">
                    <i class="ms-1 fas fa-envelope"></i>
                    البريد الإلكتروني</label
                  >
                  <input
                    type="email"
                    class="form-control"
                    id="adminEmail"
                    aria-describedby="emailHelp"
                    placeholder="البريد الالكتروني..."
                    required
                    v-model="email"
                  />
                </div>
                <div class="mb-3 form-group">
                  <label for="adminPassword" class="form-label">
                    <i class="ms-1 fas fa-lock"></i>
                    رمز المرور
                  </label>
                  <input
                    type="password"
                    class="form-control"
                    placeholder="رمز المرور..."
                    id="adminPassword"
                    required
                    aria-describedby="passwordHelp"
                    v-model="password"
                  />
                </div>
                <button class="primary-btn w-100 mt-4" type="submit">
                  تسجيل الدخول
                </button>
              </form>
            </div>
          </div>
          <div class="col-lg-8 d-lg-flex d-none">
            <img class="w-100" src="@/assets/login.svg" alt="" />
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup>
import { ref } from "vue";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";

const email = ref("");
const password = ref("");
const errMsg = ref("");
const isload = ref(false);
const router = useRouter();
const register = () => {
  const auth = getAuth();
  isload.value = true;
  signInWithEmailAndPassword(auth, email.value, password.value)
    .then(() => {
      router.push("/admin/dashboard");
      console.log("success");
    })
    .catch((e) => {
      errMsg.value = e.message;
      isload.value = false;

      switch (e.code) {
        case "auth/invalid-email":
          errMsg.value = "Invalid email";
          break;
        case "auth/user-not-found":
          errMsg.value = "User not found";
          break;
        case "auth/wrong-password":
          errMsg.value = "Wrong password";
          break;
        default:
          errMsg.value = "Unknown error";
          break;
      }

      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "error",
        title: errMsg.value,
      });
    });
};
</script>

<style lang="scss" scoped>
@import "../scss/abstracts/_mixins.scss";
.login {
  position: relative;
  overflow: hidden;
  background-color: var(--bg-app);
  &__background {
    position: absolute;
    width: 1300px;
    height: 1000px;
    top: -50%;
    left: -45%;
    z-index: -1;
  }
  &__loading {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.35);
    z-index: 99;
    .spinner-border {
      width: 3rem;
      height: 3rem;
    }
  }
  section {
    min-height: 100vh;
    @include flex($direction: column, $justify: center, $align: center);
    .login_form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
    }
    h1 {
      color: var(--font-color);
    }
  }

  .form-group {
    .form-label {
      color: var(--font-color);

      svg {
        color: var(--main-color);
      }
    }
  }
}

@include break-point(tablet) {
  .login {
    &__background {
      width: 200vw;
      height: 200vh;
      top: -40vh;
      left: -120vw;
    }
  }
}

// Keep the decorative blob from glowing through the dark theme.
@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) .login__background {
    opacity: 0.18;
  }
}

:root[data-theme="dark"] .login__background {
  opacity: 0.18;
}
</style>